import apiClient from "./client";
import type {
  DisastersListResponse,
  GetDisastersParams,
} from "../types/disaster";

export const getDisasters = async (
  params: GetDisastersParams
): Promise<DisastersListResponse> => {
  const { data } = await apiClient.get<DisastersListResponse>("/disasters", {
    params: {
      name: params.name,
      is_completed: params.is_completed,
      exclude_id: params.exclude_id,
      start_at_stt: params.start_at_stt,
      start_at_end: params.start_at_end,
      order: params.order,
      sort: params.sort,
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
